export function emptyImportTally() {
    return { added: 0, duplicates: 0, rejectedTotal: 0, rejected: [], taught: new Map() };
}
/**
 * How many problems are kept.
 *
 * Enough to see the pattern — a wrong column, a wrong delimiter — while the
 * total is still reported in full. A file where every row is malformed must not
 * return forty thousand lines.
 */
const MOST_REPORTED = 10;
/**
 * Folds one batch's answer in.
 *
 * `offset` is where this batch's rows began, so a line number points at the
 * place in the file a person is looking at rather than at position three of
 * batch eleven. Zero for a source with no line numbers of its own.
 */
export function absorbImport(tally, result, offset = 0) {
    tally.added += result.added;
    tally.duplicates += result.duplicates;
    tally.rejectedTotal += result.rejectedTotal;
    for (const problem of result.rejected) {
        if (tally.rejected.length < MOST_REPORTED) {
            tally.rejected.push({ line: problem.line + offset, reason: problem.reason });
        }
    }
    // One file teaching a column twice is one column, said once.
    for (const created of result.optionsCreated) {
        const column = tally.taught.get(created.column) ?? { options: [], noRoom: 0 };
        column.options.push(...created.options);
        column.noRoom += created.noRoom;
        tally.taught.set(created.column, column);
    }
}
export function finishedImport(tally) {
    const optionsCreated = [...tally.taught].map(([column, learnt]) => ({
        column,
        options: learnt.options,
        noRoom: learnt.noRoom,
    }));
    return {
        added: tally.added,
        duplicates: tally.duplicates,
        rejected: tally.rejected,
        rejectedTotal: tally.rejectedTotal,
        optionsCreated,
    };
}
//# sourceMappingURL=importTally.js.map